import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-page-not-found',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {

}
